<mat-dialog-content class="adap-dialog-content">
  <app-dialog-header [title]="title"></app-dialog-header>
  <ng-container *ngIf="formState$ | async as formState">
    <form novalidate [ngrxFormState]="formState" class="adap-form-container">
      <div class="form-row-2-columns">
        <app-input-container
          label="owner"
          [app-input-validation-container]="formState.controls.owner"
          [isRequired]="true"
        >
          <mat-form-field class="adap-select form-input" appearance="outline">
            <mat-select
              [ngrxFormControlState]="formState.controls.owner!"
              placeholder="select owner"
            >
              <ng-container
                *ngFor="let checkOwner of CHECK_OWNER | keyvalue : unsorted"
              >
                <mat-option [value]="checkOwner.value">
                  {{ checkOwner.value }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </app-input-container>

        <app-input-container
          label="relevant phases"
          [isRequired]="true"
          [app-input-validation-container]="formState.controls.relevantPhases"
          *ngIf="allPhases$ | async as allPhases"
        >
          <mat-form-field class="adap-select" appearance="outline">
            <mat-select
              multiple
              [ngrxFormControlState]="formState.controls.relevantPhases"
              placeholder="relevant phases"
            >
              <mat-option *ngFor="let phase of allPhases" value="{{ phase }}">
                {{ phase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </app-input-container>
      </div>

      <app-input-container
        label="scope of review"
        [isRequired]="true"
        [characterCounterLength]="
          formState.controls.scopeOfReview.value?.length ?? 0
        "
        [characterCounterMaxLength]="SCOPE_OF_REVIEW_MAX_LENGTH"
        [app-input-validation-container]="formState.controls.scopeOfReview"
      >
        <textarea
          id="scopeOfReview"
          name="scopeOfReview"
          type="text"
          class="adap-form-textarea text-area-container"
          [ngrxFormControlState]="formState.controls.scopeOfReview"
        >
        </textarea>
      </app-input-container>
    </form>
    <div class="dialog-actions">
      <button class="adap-btn-outline" type="button" (click)="closeWindow()">
        cancel
      </button>
      <ng-container>
        <ng-container>
          <button
            class="adap-btn-filled"
            type="button"
            [disabled]="!formState.isValid"
            (click)="save()"
          >
            save
          </button>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</mat-dialog-content>
